export default __webpack_public_path__ + "static/fastusdc-a4fe34630225a81edd41777aa8e6e9b4.png";